// Temporary slug while the legacy `features/insights/` feature still owns
// `/insights`. Once that feature is removed, move this feed to `/insights`.
export const TREND_DETECTION_URL = 'insights-feed'
export const AGENTS_URL = 'agents'

// Old top-level slug, kept only so LegacyIssueAgentRedirect can rewrite
// stale bookmarks onto the new URLs.
export const TREND_DETECTION_LEGACY_URL = 'issue-agent'

export const TREND_DETECTION_TRANSACTION_PATH = `/project/:id/${TREND_DETECTION_URL}`
export const TREND_DETECTION_AGENTS_TRANSACTION_PATH = `/project/:id/${AGENTS_URL}`
export const TREND_DETECTION_AGENT_CONFIG_TRANSACTION_PATH = `/project/:id/${AGENTS_URL}/:agentId`
export const TREND_DETECTION_BENCHMARKING_AGENT_TRANSACTION_PATH = `/project/:id/${AGENTS_URL}/benchmarking/:agentId`

export const trendDetectionFeedPath = (projectId: string): string =>
  `/project/${projectId}/${TREND_DETECTION_URL}`

export const trendDetectionAgentsPath = (projectId: string): string =>
  `/project/${projectId}/${AGENTS_URL}`

export const trendDetectionAgentCreatePath = (projectId: string): string =>
  `/project/${projectId}/${AGENTS_URL}/create`

export const trendDetectionAgentConfigPath = (
  projectId: string,
  agentId: string,
): string => `/project/${projectId}/${AGENTS_URL}/${agentId}`

export const trendDetectionBenchmarkingAgentPath = (
  projectId: string,
  agentId: string,
): string => `/project/${projectId}/${AGENTS_URL}/benchmarking/${agentId}`

export const trendDetectionBenchmarkingInsightPath = (
  projectId: string,
  insightId: string,
): string =>
  `/project/${projectId}/${TREND_DETECTION_URL}/benchmarking-insights/${insightId}`

export const TREND_DETECTION_INSIGHT_AGENT_TRANSACTION_PATH = `/project/:id/${AGENTS_URL}/reports/:agentUuid`

/** Detail page for one generic insight agent (its prompt, runs, insights). */
export const trendDetectionAgentDetailPath = (
  projectId: string,
  agentUuid: string,
): string => `/project/${projectId}/${AGENTS_URL}/reports/${agentUuid}`

export const TREND_DETECTION_INSIGHT_AGENT_DETAIL_TRANSACTION_PATH = `/project/:id/${TREND_DETECTION_URL}/agent-insights/:insightUuid`

/**
 * Detail page for a generic insight-agent insight. Distinct from
 * `trendDetectionBenchmarkingInsightPath` because the two render different
 * report shapes: benchmarking insights carry a structured payload, these carry
 * an Ask-Yogi-shaped markdown body plus artifacts.
 */
export const trendDetectionAgentInsightPath = (
  projectId: string,
  insightUuid: string,
): string =>
  `/project/${projectId}/${TREND_DETECTION_URL}/agent-insights/${insightUuid}`

export const TREND_DETECTION_ISSUE_DETAIL_TRANSACTION_PATH = `/project/:id/${TREND_DETECTION_URL}/issues/:issueUuid`

export const trendDetectionIssueDetailPath = (
  projectId: string,
  issueUuid: string,
): string => `/project/${projectId}/${TREND_DETECTION_URL}/issues/${issueUuid}`

export const TREND_DETECTION_UPDATE_DETAIL_TRANSACTION_PATH = `/project/:id/${TREND_DETECTION_URL}/updates/:updateUuid`

export const trendDetectionUpdateDetailPath = (
  projectId: string,
  updateUuid: string,
): string =>
  `/project/${projectId}/${TREND_DETECTION_URL}/updates/${updateUuid}`

/** Legacy agent-run flow; issue feed replaced run URLs. */
export const trendDetectionRunPath = (
  projectId: string,
  _agentId?: string,
  _runId?: string,
): string => trendDetectionFeedPath(projectId)
